"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var icons_ttf_1 = __importDefault(require("../assets/fonts/icons.ttf"));
exports.default = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @font-face {\n    font-family: 'Icons';\n    src: url(", ");\n  }\n"], ["\n  @font-face {\n    font-family: 'Icons';\n    src: url(", ");\n  }\n"])), icons_ttf_1.default);
var templateObject_1;
//# sourceMappingURL=global.js.map